import { Dayjs } from 'dayjs'
import { URLS } from './consts'
import { clearLocalStorageExceptWhitelist } from '../store/rootReducer'

export const shouldForwardProp = <Template extends Record<string, unknown>>(
  props: Array<keyof Template>,
  prop: PropertyKey,
) => !props.includes(prop as string)

// Check if the MSAL Config has changed by tenant. If it has, we need to purge the applications local storage.
export const cachePurge = () => {
  const tenant = process.env.REACT_APP_AZURE_B2C_TENANT ?? 'no_tenant'
  const storedIdentifier = localStorage.getItem('MSAL_CONFIGURED_TENANT')

  if (storedIdentifier === null) {
    localStorage.setItem('MSAL_CONFIGURED_TENANT', tenant)
  } else if (storedIdentifier !== tenant) {
    clearLocalStorageExceptWhitelist()
    localStorage.setItem('MSAL_CONFIGURED_TENANT', tenant)
  }
}

const formatter = new Intl.NumberFormat('en-NZ', {
  style: 'currency',
  currency: 'NZD',
  minimumFractionDigits: 2,
})

export const formatPrice = (price: number) => {
  return formatter.format(price)
}

export const formatNumber = (price: number) => {
  return parseFloat(price.toFixed(2))
}

export const isObjectClass = (value: unknown, className: unknown) =>
  Object.prototype.toString.call(value) === `[object ${className}]`

export const isDate = (value: unknown) => isObjectClass(value, 'Date')

export const isValidDate = (time: unknown) => isDate(time) && !isNaN((time as Date).getTime())

export const isWeekend = (date: Dayjs) => date.day() === 0 || date.day() === 6

export const addWorkingDays = (date: Dayjs, numberOfDays: number) => {
  const d = date.add(numberOfDays, 'days')
  switch (true) {
    // is saturday
    case d.day() === 6:
      return d.add(2, 'days').endOf('day')
    // is sunday
    case d.day() === 0:
      return d.add(1, 'day').endOf('day')
    default:
      return d.endOf('day')
  }
}

export const isProdEnv = () =>
  process.env.REACT_APP_AZURE_B2C_TENANT === 'farmlandsauth.onmicrosoft.com'

export const generateImageUrl = (itemId: string) =>
  URLS.imageBase + 'Products/' + itemId + '_000_001.png'
/**
 * Get the vertical scroll position of the given scroller element.
 *
 * @param scroller - The scroller element.
 * @returns The vertical scroll position.
 */
export function getScrollY(scroller: Window | HTMLElement): number {
  if ((scroller as Window).scrollY !== undefined) return (scroller as Window).scrollY
  if ((scroller as HTMLElement).scrollTop !== undefined) return (scroller as HTMLElement).scrollTop
  return (document.documentElement ?? document.body.parentNode ?? document.body).scrollTop
}

export const saveScrollYPosition = ({
  sessionStorageKey,
  position,
}: {
  sessionStorageKey: string
  position?: number
}) => {
  const scrollContainer = document.getElementById('main-scroll-container')
  const scrollY = getScrollY(scrollContainer ?? window)
  sessionStorage.setItem(
    sessionStorageKey,
    position === undefined ? scrollY.toString() : position.toString(),
  )
}
